/*
 * Two-layer application cover image used for page backgrounds and image crossfades.
 * Mounted once by the shell and updated by the shared cover service.
 * Retains stable layers while the service prepares images and transitions between route covers.
 * Example: registerComponents(registry);
 *          <BodyCover context={context}/>
 */

import { UIElement, defineUIElements } from '../../runtime/components/ui-element.js';

export class BodyCover extends UIElement {
  constructor() {
    super();
    this.captureA = (node) => (this.layerA = node);
    this.captureB = (node) => (this.layerB = node);
  }

  updated(changed) {
    super.updated(changed);
    if (!this.connection || !this.context || this.attachedTo === this.connection) return;
    this.attachedTo = this.connection;
    this.connection.own(this.context.services.covers.attach(this.layerA, this.layerB));
  }

  render() {
    const layers = (
      <>
        <div ref={this.captureA} class="body-cover-layer"/>
        <div ref={this.captureB} class="body-cover-layer"/>
      </>
    );
    return this.portal('cover', 'body', layers, { order: -100 });
  }
}

export function registerComponents(registry) {
  defineUIElements(registry, { 'tbc-body-cover': BodyCover });
}
